<script lang="ts" setup>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import VMenu from '@shared/component/VMenu/VMenu.vue';
import type { MenuItemCommandEvent } from 'primevue/menuitem';
import { useToggle } from '@vueuse/core';
import { computed, ref } from 'vue';
import { hasPermission } from '@permission/hasPermission';
import { tryMenuNavigation } from '../../urlHelper';
import ServiceDeskModal from '../ServiceDesk/ServiceDeskModal.vue';

const props = withDefaults(
  defineProps<{
    alwaysSmall?: boolean;
    iconStyle?: string;
  }>(),
  { iconStyle: 'far' },
);

const searchUserOpen = defineModel<boolean>('searchUserOpen');
const showTools = hasPermission('Inregeling.InregelingAanpassen');

const menu = ref();

const [servicedeskModalOpen, toggleServicedeskModal] = useToggle();

function openTools() {
  window.location.href = '/app/beheerbox/tools/overzicht';
}

const menuItems = computed(() => {
  const items = [
    {
      command: ({ originalEvent }: MenuItemCommandEvent) =>
        tryMenuNavigation(originalEvent, '/content/boaz/werkverdeling'),
      icon: 'far fa-sitemap',
      label: 'Werkverdeling',
      url: '/content/boaz/werkverdeling',
    },
    {
      command: ({ originalEvent }: MenuItemCommandEvent) =>
        tryMenuNavigation(originalEvent, '/content/agenda'),
      icon: 'far fa-bell',
      label: 'Agenda',
      url: '/content/agenda',
    },
    {
      command: () => (searchUserOpen.value = !searchUserOpen.value),
      icon: 'far fa-search',
      label: 'Gebruiker zoeken',
    },
    {
      command: toggleServicedeskModal,
      icon: 'far fa-user-headset',
      label: 'Servicedesk',
    },
  ];
  return showTools
    ? [
        ...items,
        {
          command: openTools,
          icon: 'far fa-tools',
          label: 'Tools',
        },
      ]
    : items;
});

function toggleMenu(event: Event) {
  menu.value.toggle(event);
}
</script>

<template>
  <div class="relative flex">
    <button
      title="Intern"
      class="flex cursor-pointer items-center gap-1 border-none bg-transparent px-3 text-sm text-inherit outline-none"
      :class="{
        'lg:px-6': !props.alwaysSmall,
      }"
      type="button"
      @click="toggleMenu"
    >
      <FontAwesomeIcon size="lg" :icon="[props.iconStyle, 'users']" />
    </button>

    <VMenu
      append-to="self"
      class="top-full! right-0! left-auto!"
      :model="menuItems"
      popup
      ref="menu"
    />

    <ServiceDeskModal v-model:is-open="servicedeskModalOpen" />
  </div>
</template>
